export const getSliderMarks = (start: number, end: number) => {
  const numElements = 10
  const step = (end - start) / (numElements - 1);
  return Array.from({length: numElements}, (_, i) => ({value: start + i * step}))
}

const hslToHex = (h: any, s: any, l: any) => {
  h /= 360;
  s /= 100;
  l /= 100;

  let r, g, b;

  if (s === 0) {
    r = g = b = l;
  } else {
    const hue2rgb = (p: any, q: any, t: any) => {
      if (t < 0) t += 1;
      if (t > 1) t -= 1;
      if (t < 1 / 6) return p + (q - p) * 6 * t;
      if (t < 1 / 2) return q;
      if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
      return p;
    };

    const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    const p = 2 * l - q;
    r = hue2rgb(p, q, h + 1 / 3);
    g = hue2rgb(p, q, h);
    b = hue2rgb(p, q, h - 1 / 3);
  }

  const toHex = (x: any) => {
    const hex = Math.round(x * 255).toString(16);
    return hex.length === 1 ? '0' + hex : hex;
  };

  return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
};

export const generateUniqueColors = (numColors: number) => {
  const colors = [];
  const saturation = 100;
  const lightness = 50;
  const hueIncrement = 360 / numColors;

  for (let i = 0; i < numColors; i++) {
    const hue = (i * hueIncrement) % 360;
    const color = hslToHex(hue, saturation, lightness);
    colors.push(color);
  }

  return colors;
}


export const generatePopupContent = (event: any, isPopUp: boolean) => {
  let warehouseZipcodeId, pref, zip, investment, expectedProfit, expectedPercentage, expectedTruckLoad,
    coveredHousehold, coveredZipcode, city, county, state = null
  if (isPopUp) {
    warehouseZipcodeId = event.warehouseZipcodeId
    pref = event.pref
    zip = event.zipcode
    investment = event.investment
    expectedProfit = event.expectedProfit
    expectedPercentage = event.expectedPercentage
    expectedTruckLoad = event.expectedTruckLoad
    coveredHousehold = event.coveredHousehold
    coveredZipcode = event.coveredZipcode
  } else {
    const feature = event.feature
    warehouseZipcodeId = feature.getProperty('warehouseZipcodeId')
    pref = feature.getProperty('pref')
    investment = feature.getProperty('investment')
    expectedProfit = feature.getProperty('expectedProfit')
    expectedPercentage = feature.getProperty('expectedPercentage')
    expectedTruckLoad = feature.getProperty('expectedTruckLoad')
    coveredHousehold = feature.getProperty('coveredHousehold')
    coveredZipcode = feature.getProperty('coveredZipcode')
    zip = feature.getProperty('zipCode')
    city = feature.getProperty('city')
    county = feature.getProperty('county')
    state = feature.getProperty('state')
  }

  let filteredRow = ''
  if (!isPopUp) {
    filteredRow = `
        <div class='nav-container-col'>
            <div class='nav-container-title'>City</div>
            <div class='nav-container-value'>${city}</div>
        </div>  
        <div class='nav-container-col'>
            <div class='nav-container-title'>County</div>
            <div class='nav-container-value'>${county}</div>
        </div>   
        <div class='nav-container-col'>
            <div class='nav-container-title'>State</div>
            <div class='nav-container-value'>${state}</div>
        </div> 
    `
  }

  return `<div id='map-tooltip'>
                <div class='nav-bar'>
                    <div class='nav-title'>
                        <span>Warehouse Info: ${zip}</span>
                    </div>        
                </div>
                <div class='nav-container'>
                    <div class='nav-container-col'>
                        <div class='nav-container-title'>ZipCode</div>
                        <div class='nav-container-value'>${zip}</div>
                    </div>
                    ${filteredRow}
                    <div class='nav-container-col'>
                        <div class='nav-container-title'>Warehouse ID</div>
                        <div class='nav-container-value'>${warehouseZipcodeId}</div>
                    </div>  
                    <div class='nav-container-col'>
                        <div class='nav-container-title'>Warehouse Prefrence</div>
                        <div class='nav-container-value'>${pref}</div>
                    </div>
                    <div class='nav-container-col'>
                        <div class='nav-container-title'>Investment ($)</div>
                        <div class='nav-container-value'>${investment || '-'}</div>
                    </div>                     
                    <div class='nav-container-col'>
                        <div class='nav-container-title'>Expected Profit ($)</div>
                        <div class='nav-container-value'>${expectedProfit || '-'}</div>
                    </div>   
                    <div class='nav-container-col'>
                        <div class='nav-container-title'>Expected Percent Of Retrns Per Month</div>
                        <div class='nav-container-value'>${expectedPercentage || '-'}</div>
                    </div>                  
                    <div class='nav-container-col'>
                        <div class='nav-container-title'>Expected Truck Loads Transport Per Month</div>
                        <div class='nav-container-value'>${expectedTruckLoad || '-'}</div>
                    </div>
                    <div class='nav-container-col'>
                        <div class='nav-container-title'>Covered House Holds</div>
                        <div class='nav-container-value'>${coveredHousehold || '-'}</div>
                    </div>   
                    <div class='nav-container-col'>
                        <div class='nav-container-title'>Covered No Of Zipcodes</div>
                        <div class='nav-container-value'>${coveredZipcode || '-'}</div>
                    </div>                  
                </div>
            </div>`
}
